import { translateKey } from '../../translate';
import { Dropdown, NullableInputText } from './common';
import { Component } from './Component';

interface IStateSelectProps {
    country: string | null;
    error?: string;
    onChange: (value: string | null) => Promise<void>;
    onDoValidate?: () => Promise<void>;
    value: string | null;
}

export class StateSelect extends Component<IStateSelectProps, {}> {
    public render() {
        if (this.props.country === 'NL') {
            return (
                <Dropdown
                    {...this.props}
                    selectOptions={[
                        { value: '', text: translateKey('common.state') },
                        { value: 'Drenthe', text: 'Drenthe' },
                        { value: 'Flevoland', text: 'Flevoland' },
                        { value: 'Friesland', text: 'Friesland' },
                        { value: 'Gelderland', text: 'Gelderland' },
                        { value: 'Groningen', text: 'Groningen' },
                        { value: 'Limburg', text: 'Limburg' },
                        { value: 'Noord-Holland', text: 'Noord-Holland' },
                        { value: 'Noord-Brabant', text: 'Noord-Brabant' },
                        { value: 'Overijssel', text: 'Overijssel' },
                        { value: 'Utrecht', text: 'Utrecht' },
                        { value: 'Zeeland', text: 'Zeeland' },
                        { value: 'Zuid-Holland', text: 'Zuid-Holland' },
                    ]}
                />
            );
        } else {
            return (
                <NullableInputText
                    {...this.props}
                    placeholder={translateKey('common.state')}
                />
            );
        }
    }
}
